export const legacyPayoutsDashboardRouteKey = 'legacyPayoutsDashboard';
